import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ProfileCollectionItem } from '@app/profile/profile-api.model';
import { UserPosition } from '@app/inputs/inputs-api.model';

@Component({
  selector: 'dgx-user-experience-details-modal',
  templateUrl: './user-experience-details-modal.component.html',
  styleUrls: ['./user-experience-details-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserExperienceDetailsModalComponent implements OnInit {
  // bindings
  @Input() public userExperience: ProfileCollectionItem<UserPosition>;

  public userExperienceContent: UserPosition;
  // local
  public i18n = this.translate.instant([
    'Core_ExperienceDisplayName',
    'PositionFormCtrl_Organization',
    'PositionFormCtrl_Seniority',
    'PositionFormCtrl_Description',
    'dgUserOutcomeEditForm_StartDate',
    'dgUserOutcomeEditForm_EndDate',
    'Core_Close',
    'ProfileCtrl_ExperienceDatePresent',
  ]);

  public titleLimit = 50;

  private showSkillsCount: number = 4;

  constructor(
    private activeModal: NgbActiveModal,
    private translate: TranslateService
  ) {}

  public ngOnInit() {
    this.userExperienceContent = this.userExperience.content as UserPosition;
  }

  public get displayedSkillNames(): string[] {
    return this.userExperienceContent.tags
      .slice(0, this.showSkillsCount)
      .map((s) => s.title);
  }

  public get extraSkillCount() {
    return this.userExperienceContent.tags.length - this.showSkillsCount;
  }

  public onCancel(): void {
    this.activeModal.close();
  }

  public onModalMenu(): void {
    this.activeModal.close();
  }
}
